import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  slideUpDialog: {
    borderRadius: 30,
  },
  slideUpDialogGrid: {
    padding: "40px 45px 45px 40px",
  },
  title: {
    flexDirection: "column",
  },
  formContainer: {
    alignItems: "center",
  },
}));
